import { useSelector } from 'react-redux';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Link, Typography } from '@mui/material';

import { AlertMessage } from '~/pages/CreateQR/sub-components/pdfTemplate/sub-components/AlertMessage';
import { getPdfReducer } from '~/store/reducers/previewScreens/pdf/selectors';
import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

type PDF_TEMPLATE_3Props = {
  isMyMicrosite?: boolean;
};
export function PDF_TEMPLATE_3({ isMyMicrosite }: PDF_TEMPLATE_3Props) {
  const pdfState = useSelector(getPdfReducer);

  const {
    bacgkroundColor,
    micrositeStyles,
    fonts: { head, text },
    basicInformation: { images, coverImage },
    pdfInformation: { company, title, description, website },
  } = pdfState;

  return (
    <Box
      sx={{
        ...mainPreviewContainerStyles,
        alignItems: 'normal',
        background: bacgkroundColor[0],
        ...micrositeStyles?.container,
        margin: isMyMicrosite ? undefined : '0 12px',
        width: isMyMicrosite ? '100%' : 'calc(100% - 24px)',
        height: 'calc(100% - 28px)',
        ...(isMyMicrosite ? { borderRadius: 0, minHeight: '100dvh' } : {}),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          minWidth: '100%',
          position: 'relative',
          height: '100%',
        }}
      >
        {!!images.length || company || title || description || website ? (
          <Box sx={{ padding: '0 1rem' }}>
            <Typography
              sx={{ fontFamily: text, fontSize: 12, mt: 3, mb: 2, wordBreak: 'break-word', color: COLORS.white }}
            >
              {company}
            </Typography>
            {!!coverImage?.img && (
              <Box
                sx={{
                  backgroundColor: COLORS.white,
                  borderRadius: '50%',
                  width: 78,
                  height: 78,
                  padding: '8px',
                  display: 'flex',
                  margin: '0 auto',
                }}
              >
                <img
                  src={coverImage.img}
                  style={{ width: '62px', height: '62px', borderRadius: '50%', objectFit: 'cover' }}
                  alt="cover"
                />
              </Box>
            )}
            <Typography sx={{ fontFamily: head, fontSize: 20, mb: 2, wordBreak: 'break-word', color: COLORS.white }}>
              {title}
            </Typography>
            <Typography sx={{ fontFamily: text, fontSize: 12, mb: 2, wordBreak: 'break-word', color: COLORS.white }}>
              {description}
            </Typography>

            {images.map((item, index) => {
              return (
                <Box
                  sx={{
                    backgroundColor: COLORS.white,
                    mb: 2,
                    padding: 1.5,
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    minHeight: 44,
                  }}
                  onClick={() => window.open(item?.previewPdfLink, '_blank')}
                  key={index}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {item?.previewLink ? (
                      <img
                        src={item?.previewLink}
                        style={{ height: 28, width: 28, objectFit: 'cover', borderRadius: '8px' }}
                        alt="cover"
                      />
                    ) : null}
                    <Box sx={{ ml: 1, textAlign: 'left' }}>
                      <Typography sx={{ color: COLORS.black, fontSize: 11, wordBreak: 'break-word' }}>
                        {item?.name || item?.path}
                      </Typography>
                      <Typography sx={{ color: COLORS.disableGrayColor, fontSize: 11, wordBreak: 'break-word' }}>
                        {item?.description}
                      </Typography>
                    </Box>
                  </Box>
                  <ChevronRightIcon sx={{ color: COLORS.disableGrayColor, fontSize: '16px' }} />
                </Box>
              );
            })}

            <Typography sx={{ fontFamily: text, fontSize: 13, mt: 2, mb: 2 }}>
              <Link
                href={website}
                target="_blank"
                sx={{ textDecoration: 'none', color: COLORS.white, wordBreak: 'break-word', pl: 1, pr: 1 }}
              >
                {website}
              </Link>
            </Typography>
          </Box>
        ) : (
          <AlertMessage />
        )}
      </Box>
    </Box>
  );
}
